"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../../Icons/index");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectOffersAccordionBoxHeader = function SelectOffersAccordionBoxHeader(_ref) {
  var children = _ref.children,
      open = _ref.open,
      toggle = _ref.toggle;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    onClick: toggle
  }, children, /*#__PURE__*/_react.default.createElement(ToggleWrapper, {
    open: open
  }, /*#__PURE__*/_react.default.createElement(_index.IconActionDropDown, null)));
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["position:relative;width:100%;padding:2.7rem 6.5rem 2.7rem 2.7rem;cursor:pointer;"]);

var ToggleWrapper = _styledComponents.default.div.withConfig({
  displayName: "ToggleWrapper"
})(["position:absolute;top:50%;right:2rem;transform:", ";cursor:pointer;transition:transform 0.2s cubic-bezier(0.85,0,0.15,1);svg path{stroke:", ";}"], function (_ref2) {
  var open = _ref2.open;
  return open ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ui.outline;
});

SelectOffersAccordionBoxHeader.propTypes = {
  children: _propTypes.node,
  open: _propTypes.bool,
  toggle: _propTypes.func
};
var _default = SelectOffersAccordionBoxHeader;
exports.default = _default;